import { ReactNode, useEffect, useState } from 'react';
import AnimateHeight, { Height } from 'react-animate-height';
import cx from 'classnames';

import { SvgIcon } from '@/components';

import styles from './TransactionAlertsTableGroup.module.sass';

interface TransactionAlertsTableGroupInterface {
  isExpanded?: boolean;
  title: string;
  firstText?: string;
  secondText?: string;
  children?: ReactNode;
  onClick: () => void;
}

export const TransactionAlertsTableGroup = ({
  isExpanded = false,
  title,
  firstText,
  secondText,
  children,
  onClick,
}: TransactionAlertsTableGroupInterface) => {
  const [childrenHeight, setChildrenHeight] = useState<Height>(0);

  useEffect(() => {
    setChildrenHeight(isExpanded ? 'auto' : 0);
  }, [isExpanded]);

  const classes = cx(styles.group, {
    [styles['is-active']]: isExpanded,
  });

  return (
    <div className={classes}>
      <div className={styles.header} onClick={onClick}>
        <div className={styles.category}>
          <SvgIcon name="arrow-right-short" className={styles.arrow} />
          <span>{title}</span>
        </div>

        <div className={styles.content}>
          {firstText && <div className={styles.firstText}>{firstText}</div>}
          {secondText && <div className={styles.secondText}>{secondText}</div>}
        </div>
        <div className={styles.actions} />
      </div>

      {children && (
        <AnimateHeight duration={300} height={childrenHeight}>
          <div className={styles.children}>{children}</div>
        </AnimateHeight>
      )}
    </div>
  );
};
